"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileExtensionsToRegex = exports.MIMETypeToRegex = exports.splitDate = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var splitDate = function splitDate(date) {
  var dateData = date ? date.match(_regex["default"].dates.splitDate.regex) : [];

  if (!dateData) {
    return {
      year: false,
      month: false,
      day: false
    };
  }

  return {
    year: dateData[1] || false,
    month: dateData[2] || false,
    day: dateData[3] || false
  };
};

exports.splitDate = splitDate;

var MIMETypeToRegex = function MIMETypeToRegex(type) {
  // turns 'application/pdf,text/plain,image/png' to a
  // regex like /^(application\/pdf|text\/plain|image\/png)$/
  var MIMETypes = type.replace(" ", "").split(",").map(function (t) {
    return t.replace("/", "\\/");
  });
  return new RegExp("^(".concat(MIMETypes.join("|"), ")$"));
};

exports.MIMETypeToRegex = MIMETypeToRegex;

var fileExtensionsToRegex = function fileExtensionsToRegex(extensions) {
  // turns '.png,.jpeg,.pdf' to a
  // regex like /(png|PNG|jpeg|JPEG|pdf|PDF)$/
  var fileExtensions = extensions.split(",").reduce(function (acc, ext) {
    var extension = ext.substr(ext.lastIndexOf(".") + 1).replace("/", "\\/");
    acc.push(extension, extension.toUpperCase());
    return acc;
  }, []);
  return new RegExp("(".concat(fileExtensions.join("|"), ")$"));
};

exports.fileExtensionsToRegex = fileExtensionsToRegex;